/**
 * A scan (`structures/{id}`) as the app reads it: its stored fields under
 * its OWN record id. A few records store a stray `id` field too, and a
 * project copy once carried the SOURCE's there — read the other way round
 * (`{ id, ...data }`), the stored one won and the copy opened as the
 * original: Create estimate refused it, and a save could have written to
 * the source (2026-10-14). Pure — no Firebase — so tests can import it.
 */
export const structureFromSnap = (snap) => ({ ...snap.data(), id: snap.id });
